import { useLocation } from "react-router-dom";
import { TFLocationState } from "types/topicflow";

import { useLink } from "@components/link/link";
import Sidebar from "@components/sidebar/sidebar";

import Assessment from "./assessment";

const AssessmentSidebarRoute = () => {
  const location = useLocation<TFLocationState>();
  const link = useLink();

  const handleCloseSidebar = () => {
    if (location.state?.background) {
      return link.replace(location.state.background);
    }
    link.redirect("/");
  };

  return (
    <Sidebar onClose={handleCloseSidebar} expandToUrl={location.pathname}>
      <Assessment isInSidebar />
    </Sidebar>
  );
};

export default AssessmentSidebarRoute;
